var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4926_61919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.40078 16H13.6008C14.4844 16 15.2008 15.2837 15.2008 14.4V4.20832C15.2008 3.81646 15.057 3.43822 14.7966 3.14534L12.4781 0.537018C12.1745 0.195436 11.7393 0 11.2823 0H2.40078C1.51713 0 0.800781 0.716345 0.800781 1.6V14.4C0.800781 15.2837 1.51713 16 2.40078 16Z",
    fill: "#5985FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40039 4.8C4.40039 4.35817 4.75856 4 5.20039 4H10.8004C11.2422 4 11.6004 4.35817 11.6004 4.8C11.6004 5.24183 11.2422 5.6 10.8004 5.6H5.20039C4.75856 5.6 4.40039 5.24183 4.40039 4.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40039 8.00313C4.40039 7.5613 4.75856 7.20312 5.20039 7.20312H10.8004C11.2422 7.20312 11.6004 7.5613 11.6004 8.00313C11.6004 8.44495 11.2422 8.80313 10.8004 8.80313H5.20039C4.75856 8.80313 4.40039 8.44495 4.40039 8.00313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40039 11.1984C4.40039 10.7566 4.75856 10.3984 5.20039 10.3984H7.60039C8.04222 10.3984 8.40039 10.7566 8.40039 11.1984C8.40039 11.6403 8.04222 11.9984 7.60039 11.9984H5.20039C4.75856 11.9984 4.40039 11.6403 4.40039 11.1984Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4926_61919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.d7cdda8e7d2dff127618c94e1512b0b9.svg";
export { ForwardRef as ReactComponent };